import { requestPost } from '@/utils/request';

export interface TEntryForm {
  batchId: string;
  entryValue: TEntryValue[];
}

/**
 * 提交的报名表单数据
 */
export interface TEntryValue {
  /**
   * 字段ID
   */
  id: string;
  /**
   * 字段名称
   */
  name: string;
  /**
   * 用户选择的字段值
   */
  value: any;
}

/**
 * 打卡营报名
 * @param data
 */
export const entry = async (data: TEntryForm) => {
  return requestPost(`/v2/camp/api/study/entry`, data);
};
